// extracted by mini-css-extract-plugin
export var circle = "_dz-1";
export var exitConfirmationModal = "_dz-5";
export var iframe = "_dz-0";
export var offline = "_dz-3";
export var online = "_dz-2";
export var workstationSelectError = "_dz-4";